import {connect} from 'react-redux'
import ProgressBar from 'components/ProgressBar'
import Nav from 'components/Nav'
import SubNavReport from 'components/SubNav/SubNavReport'
import SubNavSetting from 'components/SubNav/SubNavSetting'
import SubNavLibrary from 'components/SubNav/SubNavLibrary'
import SubNavCustomer from 'components/SubNav/SubNavCustomer'
import SubNavEmployee from 'components/SubNav/SubNavEmployee'
import NotificationBar from 'components/Notification/NotificationBar'
import SubNavOutlet from 'components/SubNav/SubNavOutlet'
import SubNavInventory from 'components/SubNav/SubNavInventory'
import SubNavIngredient from 'components/SubNav/SubNavIngredient'
import PerfectScroll from 'perfect-scrollbar'
import SubscriptionExpiredModal from 'components/SubscriptionExpiredModal'
import {closeModal} from 'actions/subscriptionExpired'
import BillingReminder from 'components/BillingReminder'
import addIdentify from 'mixpanel/identify'

class App extends React.Component {
  componentDidMount () {
    const {loggedIn, user} = this.props.data.moka
    if (loggedIn) {
      addIdentify(user.id)
    }

    if (!(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()))) {
      var containerScroll = document.getElementById('scroll-auto')
      PerfectScroll.initialize(containerScroll)
    }
  }
  render () {
    let {data, history, dispatch, location, routes, children} = this.props
    let {pathname} = location
    let {moka, notification, outlet, subscriptionExpired} = data
    let {loggedIn, user, currentlySending, showLoadingSpinner} = moka
    let {currentOutlet, outlets} = outlet
    let hideHeader = routes[1].hideHeader
    let {expired, showSubscriptionExpiredModal} = subscriptionExpired

    return (
      <div>
        {showLoadingSpinner
          ? <div id='loading-container' className='mk-loading-container'>
            <div className='center-spinner moka-spinner' />
          </div>
        : <ProgressBar updateTime={500} />}
        {!hideHeader && <header className='mk-head-bar'>
          <Nav
            loggedIn={loggedIn}
            user={user}
            currentlySending={currentlySending}
            history={history}
            dispatch={dispatch}
            location={location}
            currentOutlet={currentOutlet}
            outlets={outlets}
            />
          {pathname.startsWith('/reports') &&
            <SubNavReport
              location={location}
              user={user}
              subscriptionExpired={subscriptionExpired} />}
          {pathname.startsWith('/settings') &&
            <SubNavSetting
              user={user}
              location={location}
              isMobile={window.innerWidth <= 768}
              subscriptionExpired={subscriptionExpired} />}
          {pathname.startsWith('/library') &&
            <SubNavLibrary
              user={user}
              location={location}
              subscriptionExpired={subscriptionExpired} />}
          {pathname.startsWith('/customers') &&
            <SubNavCustomer
              location={location}
              user={user}
              subscriptionExpired={subscriptionExpired} />}
          {pathname.startsWith('/employees') &&
            <SubNavEmployee
              user={user}
              location={location}
              subscriptionExpired={subscriptionExpired} />}
          {pathname.startsWith('/outlets') &&
            <SubNavOutlet
              location={location}
              user={user}
              subscriptionExpired={subscriptionExpired} /> }
          {pathname.startsWith('/inventory') &&
            <SubNavInventory
              user={user}
              location={location}
              subscriptionExpired={subscriptionExpired} />}
          {pathname.startsWith('/ingredient') &&
            <SubNavIngredient
              user={user}
              location={location}
              subscriptionExpired={subscriptionExpired} />}
          {!hideHeader && <NotificationBar dispatch={dispatch} notification={notification} location={location} /> }
        </header>}

        <div className='separator' />
        <div className={`full-height section-content ${hideHeader ? ' no-header' : ''} ${this._getClassByPath()}`}>
          {!pathname.startsWith('/dashboard') &&
          <div className='visible-sm visible-xs reminder-responsive'>
            <BillingReminder user={user} subscriptionExpired={subscriptionExpired} />
          </div>}
          <div className='container-full-nosub box-content-container' id='scroll-auto'>
            {children}
          </div>
        </div>
        {expired &&
          <SubscriptionExpiredModal showModal={showSubscriptionExpiredModal} onHide={this._hideExpiredModal} />}
      </div>
    )
  }
  _getClassByPath () {
    let {location} = this.props
    let classbyPath = location.pathname.split('/')
    if (location.pathname.startsWith('/feedback')) {
      return 'feedback'
    }
    if (classbyPath[1] === 'reset-password') {
      return 'reset-password'
    }
    return classbyPath[classbyPath.length - 1]
  }

  _hideExpiredModal = () => {
    this.props.dispatch(closeModal())
  }
}

App.propTypes = {
  data: React.PropTypes.object,
  history: React.PropTypes.object,
  location: React.PropTypes.object,
  children: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  outlets: React.PropTypes.array
}

function select (state) {
  return {
    data: state
  }
}

export default connect(select)(App)



// WEBPACK FOOTER //
// ./app/pages/App.js